export default __webpack_public_path__ + "static/media/1881.78c710ec.png";